import { render, staticRenderFns } from "./Testimonial3.vue?vue&type=template&id=62de34a2&"
import script from "./Testimonial3.vue?vue&type=script&lang=js&"
export * from "./Testimonial3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports